import React, { useEffect } from 'react'
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import { Separator } from '../../utils/utils';

const SingleChoice = ({ item }) => {

    const selectedOptions = item.selectedOptions?.split(Separator).length > 0
        ? item.selectedOptions.split(Separator).map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];

            const metaMatch = optStr.match(/\[(.*?)\]/);
            let textResponse = "false";
            let hintText = "";
            let value = "";

            if (metaMatch) {
                const parts = metaMatch[1].split("|");
                parts.forEach(p => {
                    if (p.startsWith("TR=")) textResponse = p.split("=")[1];
                    if (p.startsWith("hintText=")) hintText = p.split("=")[1].replace(/'/g, "");
                    if (p.startsWith("value=")) value = p.split("=")[1].replace(/'/g, "");
                });
            }

            return {
                content: baseLabel,
                checked: hasSelected,
                textResponse: textResponse,
                hintText: hintText,
                value: value
            };
        })
        : [];
    // let selectedItem = selectedOptions.find(item => item?.checked);
    // console.log("selectedOptionsSC", item.selectedOptions, selectedOptions)


    /////////////// checked or TR check ////////////
    return (
        <div className="d-flex  gap-15">
            <label htmlFor="" className="text fs-14 ar-light-color w-231px text-end">{item.content}</label>
            <div className="">
                {/* {console.log("selectedOptions12345", selectedOptions)} */}
                {selectedOptions.length > 0 &&
                    selectedOptions.map((option, index) => (
                        <div className="d-flex gap-1 align-items-center">
                            {selectedOptions && selectedOptions[index]?.checked &&
                                <>
                                    <p className="text fs-14 text-black">{option.content}</p>
                                    {option?.checked && option.textResponse === "true" && (

                                        <p className="text fs-14 text-black">{option.value ? `- ${option.value}` : <></>}</p>
                                    )}
                                </>}
                        </div>))}
                {selectedOptions?.every(it => it.checked === false) && <p className="text fs-14 text-black">N/A</p>}
            </div>
        </div>
    );
};
export default SingleChoice